import { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { ensureGeoResolved, reopenConsentBanner } from '../consent/consentStore';
import { flushLegalOutbox } from './legalOutbox';

export function LegalOutboxHost() {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('cookiePreferences') === 'open') {
      // A pending geo response must not hide an explicitly opened preference panel.
      void ensureGeoResolved().then(reopenConsentBanner);
      url.searchParams.delete('cookiePreferences');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
    const retry = () => { void flushLegalOutbox(auth.currentUser); };
    const unsubscribe = onAuthStateChanged(auth, retry);
    const timer = window.setInterval(retry, 30_000);
    window.addEventListener('online', retry);
    window.addEventListener('storage', retry);
    return () => {
      unsubscribe(); window.clearInterval(timer);
      window.removeEventListener('online', retry); window.removeEventListener('storage', retry);
    };
  }, []);
  return null;
}
